let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bg3Ff")).then(() => parcelRequire('aBo2F'));